export class SerializeClass {

	fromJson(json) {
		return Object.assign(this, json)
	}

	fromJsonSafe(...sources) {
		const proto = Object.getPrototypeOf(this);
		const safe = sources.map(source => {
			if(source){
				let entries = Object.entries(source);
				let reduced = entries.reduce((accumulator, currentValue) => {
					const descriptor = Object.getOwnPropertyDescriptor(proto, currentValue[0]);
					if (!descriptor || descriptor.set) {
						accumulator.push(currentValue);
					}
					return accumulator;
				}, []);
				return Object.fromEntries(reduced);
			}

		});
		return Object.assign(this, ...safe);
	}

	fromJsonDeep(...sources) {
		this.deepAssign(this, sources)
		return this;
	}

	deepAssign(target: object, ...sources: object[]): object {
		for (const source of sources) {
			for (const key in source) {
				if (source.hasOwnProperty(key)) {
					const sourceValue = source[key];
					const targetValue = target[key];

					if (this.isObject(sourceValue) && this.isObject(targetValue)) {
						this.deepAssign(targetValue, sourceValue);
					} else {
						target[key] = sourceValue;
					}
				}
			}
		}

		return target;
	}

	isObject(obj: any): boolean {
		return obj !== null && typeof obj === 'object';
	}

	serialize() {
		// const properties = Object.getOwnPropertyNames(this);
		const properties = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this));
		const serialized = {};

		Object.keys(properties).forEach((property) => {

			if(properties[property].get){
				serialized[property] = this.serializeValue(this[property]);
			}

		});

		return serialized;
	}

	toJson(outputGetterOnly: boolean = false) {
		if(outputGetterOnly){
			return JSON.stringify(this.serialize());
		}

		return JSON.stringify(this).replace(/"_/g, '"')
	}

	toObject(outputGetterOnly: boolean = false) {
		return JSON.parse(this.toJson(outputGetterOnly))
	}

	/**
	Export to JSON including all methods, including get only methods that don't have a real value
	*/
	toJsonFull():string {
		return this.toJson(true);
	}

	private serializeValue(value) {
		if (Array.isArray(value)) {
			return value.map((item) => this.serializeValue(item));
		} else if (value instanceof SerializeClass) {
			return value.serialize();
		} else {
			return value;
		}
	}
}